import React from "react";

// Lightweight formatter: **bold**, `code`, bullet lists, numbered lists, line breaks.
function renderInline(text, keyPrefix) {
  const nodes = [];
  const regex = /(\*\*[^*]+\*\*|`[^`]+`)/g;
  let last = 0;
  let m;
  let i = 0;
  while ((m = regex.exec(text)) !== null) {
    if (m.index > last) nodes.push(text.slice(last, m.index));
    const token = m[0];
    if (token.startsWith("**")) {
      nodes.push(<strong key={`${keyPrefix}-b${i}`} className="text-white font-semibold">{token.slice(2, -2)}</strong>);
    } else {
      nodes.push(<code key={`${keyPrefix}-c${i}`} className="font-vt323 text-gp-gold bg-black/30 px-1.5 rounded">{token.slice(1, -1)}</code>);
    }
    last = m.index + token.length;
    i++;
  }
  if (last < text.length) nodes.push(text.slice(last));
  return nodes;
}

export default function MessageContent({ text }) {
  if (!text) return null;
  const lines = text.split("\n");
  const blocks = [];
  let list = null;

  const flush = () => {
    if (list) {
      blocks.push(
        <ul key={`ul-${blocks.length}`} className="my-2 space-y-1.5 pl-1">
          {list.map((it, idx) => (
            <li key={idx} className="flex gap-2">
              <span className="text-gp-gold mt-0.5 shrink-0">◆</span>
              <span>{renderInline(it, `li-${blocks.length}-${idx}`)}</span>
            </li>
          ))}
        </ul>
      );
      list = null;
    }
  };

  lines.forEach((raw, idx) => {
    const line = raw.trimEnd();
    const bullet = line.match(/^\s*[-*•]\s+(.*)/);
    const numbered = line.match(/^\s*\d+[.)]\s+(.*)/);
    if (bullet) {
      list = list || [];
      list.push(bullet[1]);
    } else if (numbered) {
      list = list || [];
      list.push(numbered[1]);
    } else if (line.trim() === "") {
      flush();
    } else {
      flush();
      blocks.push(
        <p key={`p-${idx}`} className="my-1.5 text-white/90">
          {renderInline(line, `p-${idx}`)}
        </p>
      );
    }
  });
  flush();

  return <div className="text-white/90">{blocks}</div>;
}
